var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "18px",
    viewBox: "0 0 21 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1-",
    stroke: "none",
    strokeWidth: 1,
    fill: "black",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Community_home_owner_MVP-2_desktop",
    transform: "translate(-1386.000000, -16.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/edit/white",
    transform: "translate(1384.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.000000, 3.000000)",
    id: "\\uF044"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1433188,12.1280104 L15.2683161,11.0030131 C15.4440969,10.8272323 15.7499624,10.9502789 15.7499624,11.2033758 L15.7499624,16.3150961 C15.7499624,17.2467345 14.9941049,18.0025921 14.0624665,18.0025921 L1.68749598,18.0025921 C0.755857573,18.0025921 5.96855898e-13,17.2467345 5.96855898e-13,16.3150961 L5.96855898e-13,3.94012561 C5.96855898e-13,3.0084872 0.755857573,2.25262963 1.68749598,2.25262963 L11.3027074,2.25262963 C11.5523025,2.25262963 11.6788853,2.55495893 11.5031044,2.73427597 L10.3781071,3.85927329 C10.3253729,3.91200754 10.2550605,3.94012561 10.1777101,3.94012561 L1.68749598,3.94012561 L1.68749598,16.3150961 L14.0624665,16.3150961 L14.0624665,12.3248712 C14.0624665,12.251057 14.0905845,12.1807447 14.1433188,12.1280104 Z M19.648795,5.03346864 L10.4167652,14.2654985 L7.23866835,14.6170601 C6.31756993,14.7189924 5.53359429,13.9420549 5.63552657,13.0139184 L5.98708823,9.83582154 L15.2191181,0.603791705 C16.0241737,-0.201263902 17.3249518,-0.201263902 18.1265056,0.603791705 L19.6452588,2.12254495 C20.4503487,2.92763489 20.4503487,4.23191492 19.648795,5.03346864 Z M16.1753383,6.11980791 L14.1327788,4.07724839 L7.60076999,10.6127591 L7.34413685,12.9084499 L9.63982763,12.6518167 L16.1753383,6.11980791 Z M18.4534854,3.3178546 L16.9347321,1.79910135 C16.7905712,1.65497481 16.5550524,1.65497481 16.4144277,1.79910135 L15.3280885,2.88544062 L17.370648,4.92800014 L18.4569872,3.84169521 C18.5976119,3.69403244 18.5976119,3.46201548 18.4534854,3.3178546 Z",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettings);
export default __webpack_public_path__ + "static/media/account-settings.507eb29c.svg";
export { ForwardRef as ReactComponent };